const magnitude = (value: number) => Math.abs(value);

export const formatScoringBonus = (value: number) => `+${magnitude(value)}`;

export const formatScoringPenalty = (value: number) => `−${magnitude(value)}`;

export const formatBonusPenalty = (bonus: number, penalty: number) =>
  `${formatScoringBonus(bonus)} / ${formatScoringPenalty(penalty)}`;

export const scoringMagnitude = magnitude;
